export default {
  customColumns(state: any, columns: []) {
    localStorage.setItem('custom-columns', JSON.stringify(columns));
    state.customColumns = columns;
  },
};
